export async function MountVideo(props: any, el: Element) {
	const a = await import('./Components/Video');
	a.MountVideo(props, el);
}

(window as any).MountVideo = MountVideo;
